import { render, staticRenderFns } from "./MerchantInformation.vue?vue&type=template&id=3fdd8ed4&scoped=true&"
import script from "./MerchantInformation.vue?vue&type=script&lang=js&"
export * from "./MerchantInformation.vue?vue&type=script&lang=js&"
import style0 from "./MerchantInformation.vue?vue&type=style&index=0&id=3fdd8ed4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd8ed4",
  null
  
)

export default component.exports